export const ROLES = {
  ADMIN: 'Admin',
  USER: 'User'
} as const;

export type UserRole = typeof ROLES[keyof typeof ROLES];